import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Space, Table } from "antd";
import { Box, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import qs from "qs";
import { handleApiError } from "../utils/errorHandler";

const WhatsappCloud = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editWhatsappCloudId, setEditWhatsappCloudId] = useState(null);

  const [whatsappcloud, setWhatsappcloud] = useState({
    connectionname: "",
    phonenumberid: "",
    whatsappbusinessid: "",
    versionname: "",
    urllink: "",
    cloudtoken: "",
    bmid: "",
  });

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const fetchWhatsappCloudData = async () => {
    try {
      const params = {
        startreq:
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize,
        limit: tableParams.pagination.pageSize,
      };
      const response = await axios.get(
        `/api/whatsappcloud/getall?${qs.stringify(params)}`
      );
      setData(response.data);
      console.log(response.data);
    } catch (error) {
      console.log(error);
      handleApiError(error, "Something went wrong!");
    }
  };

  useEffect(() => {
    fetchWhatsappCloudData();
  }, [JSON.stringify(tableParams)]);

  const handleChangeWhatsappCloud = (e) => {
    const { name, value } = e.target;
    setWhatsappcloud({
      ...whatsappcloud,
      [name]: value,
    });
  };

  const handleAddWhatsappCloud = (e) => {
    e.preventDefault();

    const whatsappcloudData = {
      ...whatsappcloud,
    };
    if (editWhatsappCloudId) {
      axios
        .put(
          `/api/whatsappcloud/edit/${editWhatsappCloudId}`,
          whatsappcloudData
        )
        .then((res) => {
          setWhatsappcloud({
            connectionname: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            versionname: "",
            urllink: "",
            cloudtoken: "",
            bmid: "",
          });
          Swal.fire({
            title: "Whatsapp Cloud Data Updated successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWhatsappCloudData();
          });
        })
        .catch((error) => {
          // Swal.fire(
          //   "Error",
          //   "Error creating Whatsapp Cloud Data. Please try again.",
          //   "error"
          // );
          handleApiError(
            error,
            "Error creating Whatsapp Cloud Data. Please try again."
          );
        });
    } else {
      axios
        .post("/api/whatsappcloud/create", whatsappcloudData)
        .then((res) => {
          setWhatsappcloud({
            connectionname: "",
            phonenumberid: "",
            whatsappbusinessid: "",
            versionname: "",
            urllink: "",
            cloudtoken: "",
            bmid: "",
          });
          Swal.fire({
            title: "Whatsapp Cloud Data Added successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Saved",
          }).then(() => {
            fetchWhatsappCloudData();
          });
        })
        .catch((error) => {
          // Swal.fire(
          //   "Error",
          //   "Error creating Whatsapp Cloud Data. Please try again.",
          //   "error"
          // );
          handleApiError(
            error,
            "Error creating Whatsapp Cloud Data. Please try again."
          );
        });
    }
  };

  const handleDeleteWhatsappCloud = async (_id) => {
    // Show SweetAlert2 confirm dialog
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmed.isConfirmed) {
      // Show a loading spinner while holding the action
      Swal.fire({
        title: "Deleting...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .delete(`/api/whatsappcloud/delete/${_id}`)
        .then((res) => {
          fetchWhatsappCloudData();
          Swal.fire(
            "Deleted!",
            "Whatsapp Cloud Data deleted successfully!",
            "success"
          );
        })
        .catch((error) => {
          // Swal.fire("Error", "Something went wrong!", "error");
          handleApiError(error, "Something went wrong!");
        });
    }
  };

  const handleEditWhatsappCloud = (_id) => {
    const selectedWhatsappCloud = data.find((tagid) => tagid._id === _id);

    if (selectedWhatsappCloud) {
      setEditWhatsappCloudId(_id); // Set the ID of the contact being edited
      setWhatsappcloud({
        connectionname: selectedWhatsappCloud.connectionname,
        phonenumberid: selectedWhatsappCloud.phonenumberid,
        whatsappbusinessid: selectedWhatsappCloud.whatsappbusinessid,
        versionname: selectedWhatsappCloud.versionname,
        urllink: selectedWhatsappCloud.urllink,
        cloudtoken: selectedWhatsappCloud.cloudtoken,
        bmid: selectedWhatsappCloud.bmid,
      }); // Populate the form fields with the selected contact data
    }
    setIsModalOpen(true);
  };

  const handleAddWhatsappCloudButton = () => {
    setEditWhatsappCloudId(null);
    setWhatsappcloud({
      connectionname: "",
      phonenumberid: "",
      whatsappbusinessid: "",
      versionname: "",
      urllink: "",
      cloudtoken: "",
      bmid: "",
    });
  };

  const columns = [
    {
      title: "ID",
      key: "id",
      render: (text, record, index) => index + 1,
      fixed: "left",
      width: 50,
    },

    {
      title: "Connection Name",
      dataIndex: "connectionname",
      key: "connectionname",
      ellipsis: true,
      width: 250,
    },
    {
      title: "Ph. No. ID",
      dataIndex: "phonenumberid",
      key: "phonenumberid",
      ellipsis: true,
    },
    {
      title: "WABA ID",
      dataIndex: "whatsappbusinessid",
      key: "whatsappbusinessid",
      ellipsis: true,
    },
    {
      title: "Version",
      dataIndex: "versionname",
      key: "versionname",
      ellipsis: true,
      width: 80,
      textAlign: "center",
    },
    {
      title: "URL",
      dataIndex: "urllink",
      key: "urllink",
      ellipsis: true,
    },
    {
      title: "Token",
      dataIndex: "cloudtoken",
      key: "cloudtoken",
      ellipsis: true,
    },
    {
      title: "Busi. Mng. ID",
      dataIndex: "bmid",
      key: "bmid",
      ellipsis: true,
    },

    {
      title: "ACTION",
      key: "action",
      width: 150,

      render: (text, record) => (
        <Space size="middle">
          <Link
            to={{
              pathname: `/dashboard/whatsappcloud/${record._id}/generaldetails`,
              state: { entry: record }, // Pass the entire entry object as state
            }}
          >
            <button type="button" className="edit-btn">
              <i className="ri-eye-line"></i>
            </button>
          </Link>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            className="edit-btn"
            onClick={() => handleEditWhatsappCloud(record._id)}
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            onClick={() => handleDeleteWhatsappCloud(record._id)}
            className="delete-btn"
          >
            <i className="ri-delete-bin-fill"></i>
          </button>
        </Space>
      ),
    },
  ];
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedData, setSearchedData] = useState([]);

  const fetchSearchData = async () => {
    if (searchQuery.trim() !== "") {
      setLoading(true);
      try {
        const response = await axios.get(
          "/api/whatsappcloud/searchwhatsappcloud",
          {
            params: { query: searchQuery },
          }
        );
        setSearchedData(response.data.contacts);
        // console.log(response.data.contacts);
      } catch (error) {
        console.error("Error fetching search data:", error);
        handleApiError(error, "Error fetching search data");
      } finally {
        setLoading(false);
      }
    } else {
      setSearchedData([]);
    }
  };

  useEffect(() => {
    fetchSearchData();
  }, [searchQuery]);

  const getDataSource = () => {
    if (searchQuery.trim() !== "") {
      // Display searched contacts if search query is present
      return searchedData;
    } else {
      // Display all contacts by default
      return data;
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchQuery(e.target.value);
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Whatsapp Cloud</h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2">
                    {/* <!-- Button trigger modal --> */}

                    <form className="d-flex">
                      <input
                        className="form-control me-2"
                        type="search"
                        id="search"
                        placeholder="Search"
                        aria-label="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                        // onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </form>

                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      onClick={handleAddWhatsappCloudButton}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Add
                      Whatsapp Cloud
                    </button>

                    {/* <!-- Modal --> */}
                    <div
                      className="modal fade"
                      id="exampleModal"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden={!isModalOpen}
                      style={{ display: isModalOpen ? "block" : "none" }}
                    >
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                              {editWhatsappCloudId
                                ? "Update Whatsapp Cloud"
                                : "Add Whatsapp Cloud"}
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <Box>
                              <TextField
                                color="primary"
                                fullWidth
                                label="Connection Name"
                                name="connectionname"
                                value={whatsappcloud.connectionname}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="URL"
                                name="urllink"
                                value={whatsappcloud.urllink}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Phone Number ID"
                                name="phonenumberid"
                                value={whatsappcloud.phonenumberid}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Whatsapp Business ID"
                                name="whatsappbusinessid"
                                value={whatsappcloud.whatsappbusinessid}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Version"
                                name="versionname"
                                value={whatsappcloud.versionname}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Token"
                                name="cloudtoken"
                                value={whatsappcloud.cloudtoken}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                              <TextField
                                color="primary"
                                fullWidth
                                label="Business Manager ID"
                                name="bmid"
                                value={whatsappcloud.bmid}
                                onChange={handleChangeWhatsappCloud}
                                margin="normal"
                                required
                                autoFocus
                              />
                            </Box>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={handleAddWhatsappCloud}
                              type="button"
                              className="btn btn-primary"
                              data-bs-dismiss="modal"
                            >
                              {editWhatsappCloudId ? "Update" : "OK"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0"></div>
                </div>
                <div className="d-flex align-items-center flex-wrap gap-2 mt-2">
                  <div className="flex-shrink-0">
                    <div className="hstack text-nowrap gap-2 align-item-center"></div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  dataSource={getDataSource()}
                  columns={columns}
                  rowKey="_id"
                  // scroll={{ x: true }}
                  // style={{ overflowX: data.length > 5 ? "scroll" : "hidden" }} // Show scrollbar only if data is lengthy
                  // pagination={{
                  //   pageSize: 20,
                  // }}
                  pagination={{
                    ...tableParams.pagination,
                    position: "bottomRight",
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "15", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  components={{
                    header: {
                      cell: ({ style, ...restProps }) => (
                        <th
                          {...restProps}
                          style={{
                            ...style,
                            backgroundColor: "#c6c6c6",
                            color: "black",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappCloud;
